import React from 'react'

import Svg from './'

const SvgPlus = props => (
  <Svg viewBox="0 0 100 100" {...props}>
    <path d="M50,0A49.664,49.664,0,0,0,0,50a49.664,49.664,0,0,0,50,50,49.664,49.664,0,0,0,50-50A50.176,50.176,0,0,0,50,0ZM72.926,56.567H56.567V73.733H42.627V56.567H26.152V44.24H42.511V27.074H56.452V44.24H72.811V56.567Z" />
  </Svg>
)

export default SvgPlus



// WEBPACK FOOTER //
// ../source/components/Svg/SvgPlus.js